import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import {
  selectAllocations,
  selectAllocationsPagination,
  selectAllocationsFilter,
  fetchAccountAllocationsActions,
  setAccountAllocationsFilterAction,
} from '../ducks';
import { AllocationList } from '../../../features/allocation-management/components';
import { apiCallIds as allocationApiCallIds } from '../../../features/allocation-management/api';
import { selectIsInProgress } from '../../../features/spinner/ducks';

const mapStateToProps = state => ({
  allocations: selectAllocations(state),
  pagination: selectAllocationsPagination(state),
  filter: selectAllocationsFilter(state),
  isLoading: selectIsInProgress(state, allocationApiCallIds.FETCH_ALLOCATIONS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAllocations: fetchAccountAllocationsActions.request,
      setFilter: setAccountAllocationsFilterAction,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class AccountAllocationsContainer extends Component {
  static propTypes = {
    accountId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    allocations: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { filter, accountId, actions } = this.props;
    actions.fetchAllocations({
      ...filter,
      accountId,
    });
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAllocations({
      ...this.props.filter,
      accountId: this.props.accountId,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, accountId, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
      accountId,
    });
  };

  onFilterStatusChange = this.onFilterChange('status');

  render() {
    const { allocations, pagination, filter, isLoading, t, accountId } = this.props;

    return (
      <div className="padded">
        <h2>{t('Investície')}</h2>

        <AllocationList
          allocations={allocations}
          pagination={pagination}
          filter={filter}
          onTableChange={this.handleTableChange}
          onFilterStatusChange={this.onFilterStatusChange}
          isLoading={isLoading} 
          accountId={accountId}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountAllocationsContainer.js